import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import CheckIcon from './images/check.inline.svg';

import styles from './panel.module.scss';

const cx = classNames.bind(styles);

const Panel = ({ children }) => (
  <div className={cx('wrapper')}>
    <CheckIcon className={cx('icon')} />
    <span>{children}</span>
  </div>
);

Panel.propTypes = {
  children: PropTypes.string.isRequired,
};

export default Panel;
